import React, { useState } from 'react';
import './InStockFilter.scss';

const InStockFilter = props => {
  const { dataLocale } = props;

  const { IN_STOCK = 'In Stock' } = dataLocale;

  const [isSelected, setIsSelected] = useState(false);

  return (
    <div className="in-stock-filter" onClick={() => setIsSelected(!isSelected)}>
      <div className="in-stock-filter-checkbox">
        <div
          className={`in-stock-filter-checkbox__inner${
            isSelected ? ' in-stock-filter-checkbox__inner--active' : ''
          }`}
        />
      </div>
      <div className="in-stock-filter__label">{IN_STOCK}</div>
    </div>
  );
};

export default InStockFilter;
